import React, { Component } from "react";
import { Form, Tabs, Tab, Button } from "react-bootstrap";

export default class Abhalogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedvalue: "",
      mobilenumber: "",
      mobilenumbercaptcha: "",
    };
  }
  render() {
    return (
      <div>
        <div className="row mb-2">
          <div
            className="col-md-4 active-page "
            onClick={this.handleMobileNumberchange}
          >
            <div className="widget_BG widget_BG_grid fill nav-icon">
              <p className="nav-label mt-2 " onClick={this.handlechange}>
                Mobile Number
              </p>
            </div>
          </div>

          <div
            className="col-md-4 Inactive"
            onClick={this.handleMobileNumberchange}
          >
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Aadhaar Number</p>
            </div>
          </div>
          <div
            className="col-md-4 Inactive"
            onClick={this.handleMobileNumberchange}
          >
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">ABHA Number </p>
            </div>
          </div>
        </div>
        <div className="row widget_BG widget_BG_grid m-0">
          <div className="title_left">
            <h5 className="logoskybluecolor">Login To Your ABHA</h5>
          </div>
          <Tabs className="mb-3">
            <Tab eventKey="mobilenumber" title="Mobile Number">
              <div className="row">
                <Form>
                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        name="mobilenumber"
                        value={this.state.mobilenumber}
                        onChange={this.handleMobileChange}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>Captcha</Form.Label>
                      <Form.Control
                        name="mobilenumbercaptcha"
                        value={this.state.mobilenumbercaptcha}
                        onChange={this.handleMobileChange}
                      />
                    </Form.Group>
                  </div>
                </Form>
              </div>
              <div className="row">
                <div className="col text-end">
                  <Button className="rounded-0">Next</Button>
                </div>
              </div>
              <div className="row widget_BG widget_BG_grid mt-2">
                <div
                  className="col d-flex"
                  style={{ justifyContent: "center" }}
                >
                  <a href="/">Forgot your ABHA number?</a>&nbsp;|&nbsp;
                  <a href="/"> Retrieve your Enrolment Number</a>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Aadhaarnumber" title="Aadhaar Number">
              <div className="row">
                <Form>
                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>Aadhaar Number</Form.Label>
                      <Form.Control
                        name="aadhaarnumber"
                        value={this.state.aadhaarnumber}
                        onChange={this.handleAadharChange}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>Captcha</Form.Label>
                      <Form.Control
                        name="mobilenumbercaptcha"
                        value={this.state.mobilenumbercaptcha}
                        onChange={this.handleMobileChange}
                      />
                    </Form.Group>
                  </div>
                </Form>
              </div>
              <div className="row">
                <div className="col text-end">
                  <Button className="rounded-0">Next</Button>
                </div>
              </div>
              <div className="row widget_BG widget_BG_grid mt-2">
                <div
                  className="col d-flex"
                  style={{ justifyContent: "center" }}
                >
                  <a href="/">Forgot your ABHA number?</a>&nbsp;|&nbsp;
                  <a href="/"> Retrieve your Enrolment Number</a>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Abhanumber" title="ABHA Number">
              <div className="row">
                <Form>
                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>ABHA Number</Form.Label>
                      <Form.Control
                        name="abhanumber"
                        value={this.state.abhanumber}
                        onChange={this.handleABHaChange}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>Captcha</Form.Label>
                      <Form.Control
                        name="mobilenumbercaptcha"
                        value={this.state.mobilenumbercaptcha}
                        onChange={this.handleMobileChange}
                      />
                    </Form.Group>
                  </div>
                </Form>
              </div>
              <div className="row">
                <div className="col text-end">
                  <Button className="rounded-0">Next</Button>
                </div>
              </div>
              <div className="row widget_BG widget_BG_grid mt-2">
                <div
                  className="col d-flex"
                  style={{ justifyContent: "center" }}
                >
                  <a href="/">Forgot your ABHA number?</a>&nbsp;|&nbsp;
                  <a href="/"> Retrieve your Enrolment Number</a>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}
